module.exports = __webpack_public_path__ + "static/media/our-mission-1076x660.c26e3d88.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/aboutUs/assets/our-mission-1076x660.jpeg
// module id = 1305
// module chunks = 1